import Logout from "./Logout";

export default Logout;
